module.exports = __webpack_public_path__ + "img/sharp-example8.d53f80c3.jpg";